/* eslint-disable no-console */
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { Transaction } from '../../models/transaction.model'
import { TransactionService } from './transaction.service'

const EXTERNAL_FILE_MANAGER_HOST = 'helios-external-overview'

@Injectable({
  providedIn: 'root',
})
export class HttpTransactionService extends TransactionService {
  constructor(private readonly httpClient: HttpClient) {
    super()
  }

  getTransactions(executionId: number): Observable<Transaction[]> {
    return this.httpClient.get<Transaction[]>(
      `${EXTERNAL_FILE_MANAGER_HOST}/${executionId}/transactions`,
    )
  }
}
